import React, { useState } from 'react';
import LoginForm from '../components/LoginForm';
import fullLogoSrc from '../../assets/images/fullLogo.png';
import { useAuth } from '../../portal/context/auth-context';
import { useNavigate } from 'react-router-dom';
import config from '../../utils/config';
import loginBackground from '../../assets/images/loginBackground.png';
import AccountChooserModal from '../components/AccountChooserModal';

export default function LoginPage() {
    // const ORIGIN = window.location.origin;
    const ORIGIN = config.origin;
    const { login } = useAuth();
    const history = useNavigate();

    const [userAuthError, setUserAuthError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [serverError, setServerError] = useState(false);

    const [chooserOpen, setChooserOpen] = useState(false);
    const [chooserContacts, setChooserContacts] = useState([]);

    const [selectionToken, setSelectionToken] = useState(null);
    const [lastLoginPayload, setLastLoginPayload] = useState(null);

    const createUserLogin = (data, remembered, firstLogin) => {
        login(data, remembered, firstLogin);
        history('/');
    };

    const sendData = async (data, remembered, selectedContactId, selectionTokenArg) => {
        setUserAuthError(false);
        setServerError(false);

        try {
            const body = {
                emailAddress: data.email,
                ...(selectedContactId || selectionTokenArg ? {} : { password: data.password }),
                ...(selectedContactId ? { selectedContactId } : {}),
                ...(selectionTokenArg ? { selectionToken: selectionTokenArg } : {}),
            };

            const res = await fetch(`${ORIGIN}/cp/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });

            const result = await res.json();

            if (result?.success) {
                const user = result.success;
                user.userInfoAll = result.userInfoAll || user.userInfoAll || [];
                user.userInfoAllEmail = result.userInfoAllEmail || [];
                createUserLogin(user, remembered, !!result.firstLogin);
                return;
            }

            if (Array.isArray(result?.choose) && result.choose.length > 1) {
                setChooserContacts(result.choose);
                setSelectionToken(result.selectionToken || null);
                setChooserOpen(true);
                setLastLoginPayload({ data, remembered });
                return;
            }

            if (result?.failure) {
                setUserAuthError(result.failure);
                return;
            }

            setServerError(true);
        } catch (e) {
            setServerError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = (data, remembered) => {
        setIsLoading(true);
        sendData(data, remembered);
    };

    const handleConfirmChoice = (contact) => {
        setChooserOpen(false);
        if (!contact?.Id || !lastLoginPayload?.data?.email) {
            setUserAuthError('Unable to switch accounts. Please try again.');
            return;
        }

        setIsLoading(true);
        sendData(lastLoginPayload.data, lastLoginPayload.remembered, contact.Id, selectionToken);
    };

    return (
        <>
            <div className='flex min-h-screen'>
                <LoginForm
                    submitData={handleSubmit}
                    userAuthError={userAuthError}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setUserAuthError={setUserAuthError}
                    serverError={serverError}
                />
                <div className='hidden relative flex-1 w-0 lg:block'>
                    <img className='object-cover absolute inset-0 w-full h-full' src={loginBackground} alt='' />
                    <img
                        className='object-contain absolute top-10 right-24 w-3/5 h-auto'
                        width={780}
                        src={fullLogoSrc}
                        alt=''
                    />
                </div>
            </div>
            <AccountChooserModal
                isOpen={chooserOpen}
                contacts={chooserContacts}
                onCancel={() => setChooserOpen(false)}
                onConfirm={handleConfirmChoice}
            />
        </>
    );
}
